import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export const ReferralsListLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['container']}>
      <UIHeading1 color="text-primary-default">Кого вы пригласили</UIHeading1>

      <div className={styles['listing']}>{children}</div>
    </div>
  );
};
